class SimDashboardController {
    constructor($window, $browser, ModalService, toastr, UserDetails, UtpSimServiceApi, ngProgressFactory, AppServiceApi, SettingsService, ReportUtils) {
        this.$onInit = () => {
            this.init();
        };
        this.state = {
            DateFormats: null
        };
        this.alwaysRunCellRenderer = () => {
            let alwaysRun = '<div><p ng-if="data.AlwaysRun">Yes</p><p ng-if="!data.AlwaysRun">No</p></div>';
            return alwaysRun;
        };
        // TODO FIGURE OUT WHEN TO SET ACTIONS FOR ADMIN!
        this.simulatorsGridReady = () => {
            // console.log('simulatorsGridReady');
            // console.log(simulatorsColumnDefs);
            // console.log(instancesColumnDefs);
            // vm.simulatorsGridOptions.api.setColumnDefs(simulatorsColumnDefs);
            // vm.simulatorsGridOptions.api.sizeColumnsToFit();
        };
        this.timeCellRenderer = (params) => {
            let time = '<span>' +
                this.formatDate(new Date(params.data.Started)) +
                '</span>';
            return time;
        };
        this.processIdRenderer = (params) => {
            return `<span>${params.data.ProcessId === -1 ? 'N/A' : params.data.ProcessId}</span>`;
        };
        this.simulatorsColumnDefs = [
            {
                headerName: 'Simulator Name',
                field: 'SimName',
                width: 334,
                minWidth: 145,
                sort: 'asc',
                maxWidth: null,
                cellClass: null,
                cellRenderer: null,
                suppressMenu: null,
                resizable: false,
                suppressMovable: null,
                sortable: false
            },
            {
                headerName: 'Version',
                field: 'SimVersion',
                width: 95,
                minWidth: 95,
                maxWidth: null,
                cellClass: null,
                cellRenderer: null,
                suppressMenu: null,
                resizable: false,
                suppressMovable: null,
                sort: null,
                sortable: false
            },
            {
                headerName: 'Always Run',
                width: 20,
                minWidth: 105,
                maxWidth: 105,
                field: 'AlwaysRun',
                cellClass: 'text-center',
                cellRenderer: this.alwaysRunCellRenderer,
                suppressMenu: true,
                resizable: false,
                suppressMovable: true,
                sort: null,
                sortable: false
            }
        ];
        this.instancesColumnDefs = [
            {
                headerName: 'Simulator Name',
                field: 'SimName',
                width: 175,
                minWidth: 175,
                sort: 'asc',
                maxWidth: null,
                cellClass: null,
                cellRenderer: null,
                suppressMenu: null,
                resizable: false,
                suppressMovable: null,
                sortable: false
            },
            {
                headerName: 'Version',
                field: 'SimVersion',
                width: 80,
                minWidth: 80,
                maxWidth: null,
                cellClass: null,
                cellRenderer: null,
                suppressMenu: null,
                resizable: false,
                suppressMovable: null,
                sort: null,
                sortable: false
            },
            {
                headerName: 'Process Id',
                field: 'ProcessId',
                width: 100,
                minWidth: 100,
                maxWidth: null,
                cellClass: null,
                cellRenderer: this.processIdRenderer,
                suppressMenu: null,
                resizable: false,
                suppressMovable: null,
                sort: null,
                sortable: false
            },
            {
                headerName: 'Started (Local)',
                field: 'Started',
                cellRenderer: this.timeCellRenderer,
                width: 140,
                minWidth: 140,
                maxWidth: null,
                cellClass: null,
                suppressMenu: null,
                resizable: false,
                suppressMovable: null,
                sort: null,
                sortable: false
            },
            {
                headerName: 'Username',
                field: 'UserName',
                width: 135,
                minWidth: 135,
                maxWidth: null,
                cellClass: null,
                cellRenderer: null,
                suppressMenu: null,
                resizable: false,
                suppressMovable: null,
                sort: null,
                sortable: false
            }
        ];
        this.instancesGridReady = () => {
            // console.log('instancesGridReady');
            // console.log(simulatorsColumnDefs);
            // console.log(instancesColumnDefs);
            // console.log(simulatorsColumnDefs);
            // vm.instancesGridOptions.api.setColumnDefs(instancesColumnDefs);
            // vm.instancesGridOptions.api.sizeColumnsToFit();
        };
        this.simulatorsActionsCellRenderer = (params) => {
            let startButton = [
                '<span class="glyphicon btn btn-info btn-xs glyphicon-play space-left" ng-disabled="vm.maxSimulatorCapacityReached"',
                // 'ng-if="!checkProcess(', params.data.ProcessId, ')"',        // Not currently doing anything?
                'ng-click="vm.startSimulator(',
                params.data.Id,
                ')"',
                'uib-popover="Click to start simulator"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true">',
                '</span>'
            ].join(' ');
            let actions = ['<span">', startButton, '</span>'].join('');
            return actions;
        };
        this.instanceActionsCellRenderer = (params) => {
            let stop = [
                '<button',
                'class="glyphicon btn btn-info btn-xs glyphicon-off space-left space-right"',
                'popover-placement="left"',
                'popover-append-to-body="true"',
                'ng-click="vm.killProcess(',
                params.data.Simulator_Id,
                ',',
                params.data.AspNetUsers_Id,
                ',',
                params.data.ProcessId,
                ', 1,',
                params.data.ServerControllerId,
                ')"',
                'uib-popover="Click to stop simulator safely"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'ng-if="',
                params.data.Simulator_Id > 0,
                '">',
                '</button>'
            ].join(' ');
            let processKill = [
                '<button',
                'class="glyphicon btn btn-info btn-xs glyphicon-trash space-left space-right"',
                'popover-placement="left"',
                'popover-append-to-body="true"',
                'ng-click="vm.killProcess(',
                params.data.Simulator_Id,
                ',',
                params.data.AspNetUsers_Id,
                ',',
                params.data.ProcessId,
                ', 0,',
                params.data.ServerControllerId,
                ')"',
                'uib-popover="Click to stop simulator process"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'ng-if="',
                params.data.ProcessId > 0,
                '">',
                '</button>'
            ].join(' ');
            let startComms = [
                '<button',
                'class="glyphicon btn btn-info btn-xs glyphicon-play-circle space-right space-left "',
                'popover-placement="left"',
                'popover-append-to-body="true"',
                'ng-click="vm.commsStart(',
                params.data.Simulator_Id,
                ')" ',
                'uib-popover="Click to start communications"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'">',
                '</button>'
            ].join(' ');
            let stopComms = [
                '<button',
                'class="glyphicon btn btn-info btn-xs glyphicon-off space-left"',
                'popover-placement="left"',
                'popover-append-to-body="true"',
                'ng-click="vm.commsStop(',
                params.data.Simulator_Id,
                ')"',
                'uib-popover="Click to stop communications"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'">',
                '</button>'
            ].join(' ');
            // startComms, stopComms,
            let actions = ['<span>', processKill, stop, '</span>'].join('');
            return actions;
        };
        // Leaving this in case simulatorsActionsCellRenderer is changed to need it later
        // checkProcess = (processId: number) => {
        //     if (processId === null || processId === 0) {
        //         return false;
        //     }
        //     return true;
        // }
        this.toastrDisplay = (isSuccessful, goodMessage, badMessage) => {
            let message = isSuccessful ? goodMessage : badMessage;
            if (isSuccessful) {
                this.toastr.info(message);
                return;
            }
            this.toastr.warning(message);
        };
        this.getAllActiveSimulatorInstances = () => {
            this.UtpSimServiceApi.getAllActiveSimulatorInstances().then((response) => {
                if (response) {
                    this.instancesGridOptions.api.setRowData(response.data);
                    this.instancesGridOptions.api.sizeColumnsToFit();
                }
            });
            this.UtpSimServiceApi.getCountOfRunningSimulators().then((response) => {
                let resp = response.data;
                this.numberOfRunningSims = resp.RunningSimulators;
                this.maxNumberOfRunningSims = resp.MaximumRunningSimulators;
                this.maxSimulatorCapacityReached = false;
                if ((this.maxNumberOfRunningSims > -1) &&
                    (this.numberOfRunningSims >= this.maxNumberOfRunningSims)) {
                    this.maxSimulatorCapacityReached = true;
                }
            });
        };
        this.stopSim = (simID, simProcessId, serverControllerId) => {
            this.UtpSimServiceApi.killProcess(simProcessId, simID, serverControllerId).then((response) => {
                let killProcessResponse = response.data;
                if (angular.isUndefined(response)) {
                    this.toastr.error('Problem stopping process!');
                    return;
                }
                if (killProcessResponse) {
                    this.getAllActiveSimulatorInstances();
                }
                this.toastrDisplay(killProcessResponse, 'Simulator process stopped successfully.', 'Problem stopping simulator process!');
            });
        };
        this.killProcess = (simID, userID, simProcessId, stopSafely, serverControllerId) => {
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'OK',
                closeButtonText: 'Cancel',
                headerText: 'Stop Simulator',
                bodyText: 'Are you sure you want to stop simulator?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                if (stopSafely) {
                    this.UtpSimServiceApi.stopSimulatorInstance(simID, userID).then((response) => {
                        this.getAllActiveSimulatorInstances();
                        this.toastrDisplay(response.data.success, 'Simulator process stopped successfully.', 'Problem stopping simulator process!');
                    });
                }
                else {
                    this.stopSim(simID, simProcessId, serverControllerId);
                }
            });
        };
        this.startSimulator = (simulatorId) => {
            if (!this.maxSimulatorCapacityReached) {
                this.UtpSimServiceApi.startSimulator(simulatorId, this.userDetails.Id).then((response) => {
                    if (angular.isUndefined(response)) {
                        this.toastr.error('Problem starting simulator!');
                        return;
                    }
                    let startSimResp = response.data;
                    if (startSimResp) {
                        // Refresh the list of simulator processes regardless of the state
                        // of starting the simulator.
                        this.getAllActiveSimulatorInstances();
                        if (startSimResp.SimulatorStarted === false) {
                            this.toastr.error(startSimResp.SimulatorStartMessage);
                        }
                        else {
                            this.toastr.info('Simulator started successfully.');
                        }
                    }
                });
            }
            else {
                this.toastr.warning('Cannot start the simulator because the limit on the number of running simulators has been reached.');
            }
        };
        this.commsStart = (simulatorId) => {
            this.UtpSimServiceApi.commsStart(simulatorId).then((response) => {
                if (angular.isUndefined(response)) {
                    this.toastr.error('Problem starting simulator communications!');
                    return;
                }
                this.toastrDisplay(response.data, 'Simulator communications started!', 'Problem starting simulator communications!');
            });
        };
        this.commsStop = (simulatorId) => {
            this.UtpSimServiceApi.commsStop(simulatorId).then((response) => {
                if (angular.isUndefined(response)) {
                    this.toastr.error('Problem stopping simulator communications!');
                    return;
                }
                this.toastrDisplay(response.data, 'Simulator communications stopped!', 'Problem stopping simulator communications!');
            });
        };
        this.getAllSimulators = () => {
            this.UtpSimServiceApi.getAllSimulators(-1, true, true, false, false).then((response) => {
                let activeSims = response.data;
                this.simulatorsGridOptions.api.setRowData(activeSims.activeSimulatorsList);
                this.simulatorsGridOptions.api.sizeColumnsToFit();
            });
        };
        this.initAdminGrid = () => {
            if (this.userDetails.IsAdmin) {
                this.simulatorsColumnDefs.push({
                    headerName: 'Actions',
                    cellRenderer: this.simulatorsActionsCellRenderer,
                    width: 80,
                    minWidth: 60,
                    cellClass: 'text-center',
                    sortable: false,
                    suppressMenu: true,
                    resizable: false,
                    suppressMovable: true,
                    maxWidth: null,
                    field: null,
                    sort: null
                });
                this.instancesColumnDefs.push({
                    headerName: 'Actions',
                    cellRenderer: this.instanceActionsCellRenderer,
                    width: 80,
                    minWidth: 60,
                    sortable: false,
                    suppressMenu: true,
                    resizable: false,
                    suppressMovable: true,
                    maxWidth: null,
                    field: null,
                    cellClass: null,
                    sort: null,
                });
                if (this.simulatorsGridOptions.api) {
                    // console.log('Simulator GRID API AVAILABLE!');
                    this.simulatorsGridOptions.api.setColumnDefs(this.simulatorsColumnDefs);
                    this.simulatorsGridOptions.api.sizeColumnsToFit();
                }
                if (this.instancesGridOptions.api) {
                    // console.log('instance GRID API AVAILABLE!');
                    this.instancesGridOptions.api.setColumnDefs(this.instancesColumnDefs);
                    this.instancesGridOptions.api.sizeColumnsToFit();
                }
            }
        };
        this.refresh = () => {
            this.traceProgress.start();
            this.getAllSimulators();
            this.getAllActiveSimulatorInstances();
            this.traceProgress.complete();
        };
        this.init = () => {
            this.rufUrl = 'RUF/simulator/dashboard?embed=true';
            this.enableRUF = true; // Default to true, till actual value is retrieved from Configuration
            this.instancesGridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.instancesGridOptions.columnDefs = this.instancesColumnDefs;
            this.instancesGridOptions.rowHeight = 50;
            this.instancesGridOptions.onGridReady = this.instancesGridReady,
                this.simulatorsGridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.simulatorsGridOptions.columnDefs = this.simulatorsColumnDefs;
            this.simulatorsGridOptions.rowHeight = 50;
            this.simulatorsGridOptions.onGridReady = this.simulatorsGridReady;
            this.numberOfRunningSims = 0;
            this.maxNumberOfRunningSims = -1;
            this.maxSimulatorCapacityReached = false;
            // Initialise progress bar
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.traceProgress.start();
            this.AppServiceApi.settings().then((response) => {
                this.responseAppSettings = response.data;
                this.enableRUF = this.responseAppSettings.EnableRUF && this.responseAppSettings.EnableRUFComponents.some(c => c.toLowerCase() === 'simulatordashboard');
                this.state.DateFormats = {
                    DateTimeFormat: this.responseAppSettings.DateTimeFormat,
                    DateFormat: this.responseAppSettings.DateFormat,
                    TimeFormat: this.responseAppSettings.TimeFormat
                };
                if (this.responseAppSettings.UseSingleSignOn) {
                    this.instancesColumnDefs.push({
                        headerName: 'IdPEmail',
                        cellRenderer: null,
                        width: 160,
                        minWidth: 60,
                        sortable: false,
                        suppressMenu: null,
                        resizable: false,
                        suppressMovable: null,
                        maxWidth: null,
                        field: 'IdPEmail',
                        cellClass: null,
                        sort: null,
                    });
                    if (this.instancesGridOptions.api) {
                        // console.log('instance GRID API AVAILABLE!');
                        this.instancesGridOptions.api.setColumnDefs(this.instancesColumnDefs);
                        this.instancesGridOptions.api.sizeColumnsToFit();
                    }
                }
                this.UserDetails.get().then((data) => {
                    this.traceProgress.complete();
                    this.userDetails = data;
                    this.getAllSimulators();
                    this.getAllActiveSimulatorInstances();
                    this.initAdminGrid();
                }, () => {
                    this.traceProgress.complete();
                    this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                    this.window.location.href =
                        this.browser.baseHref() + 'account/login';
                    return;
                });
            });
            return;
        };
        this.onSizeChange = () => {
            this.instancesGridOptions.api.sizeColumnsToFit();
            this.simulatorsGridOptions.api.sizeColumnsToFit();
        };
        this.window = $window;
        this.browser = $browser;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.ngProgressFactory = ngProgressFactory;
        this.UtpSimServiceApi = UtpSimServiceApi;
        this.AppServiceApi = AppServiceApi;
        this.UserDetails = UserDetails;
        this.ReportUtils = ReportUtils;
    }
    formatDate(date) {
        return moment(date)
            .utc()
            .format(this.state.DateFormats.DateTimeFormat);
    }
}
angular.module('app').component('simDashboard', {
    bindings: {},
    templateUrl: 'scripts/app/partials/Dashboard/sim-dashboard.tpl.html',
    controllerAs: 'vm',
    controller: SimDashboardController
});
